import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HighlightAdapter } from '@modules/content-api/adapter/highlight.adapter';
import { ContentAPIService } from '@modules/content-api/content-api.service';
import { map } from 'rxjs/operators';

const HIGHLIGHT_PAGE_PARAMS = new HttpParams().appendAll({
  include: ['image,chapters', 'chapters.content_block', 'chapters.content_block.image'].join(),
});

@Injectable({
  providedIn: 'root',
})
export class HighlightPageService {
  constructor(private apiService: ContentAPIService, private highlightAdapter: HighlightAdapter) {}

  public getHighlights(highlightSectionId: any) {
    return this.apiService.getResource('highlights', highlightSectionId, HIGHLIGHT_PAGE_PARAMS).pipe(
      map((data) => {
        try {
          return this.highlightAdapter.parseHighlight(data);
        } catch (error) {
          return null;
        }
      })
    );
  }
}
